<template>
    <div id="select-mobile-page" class="login-page bg-cover bg-center bg-no-repeat">
        <div class='card' style='padding-top:0;'>
            <img
                :src="
                    `${$store.state.appUrl}/img/pwa/device-type/mobile-type.png`
                " 
                alt="Thrive Select Mobile Type Main"
            />
            <h2
                class="page-title color-text font-bold text-28 text-text pt-10 tracking-tight text-center"
            >
                {{ $t("Which device are you using ?") }}
            </h2>
            <img class='signin-icon device-icon iphone-icon'
                :src="
                    `${$store.state.appUrl}/img/pwa/device-type/apple.png`
                "
                alt="Thrive Select Apple Device"
            />
            <div class="table mx-auto mt-10">
                <button
                    class="btn" 
                    type="button"
                    @click="redirectToIphInstruction"
                >{{ $t('iPhone') }}</button>
            </div>
        </div>
        <div class='card my-20'>
            <img class='signin-icon device-icon android-icon'
                :src="
                    `${$store.state.appUrl}/img/pwa/device-type/android.png`
                "
                alt="Thrive Select Android Device"
            />
            <div class="table mx-auto mt-10">
                <button
                    class="btn"
                    type="button"
                    @click="redirectToAndInstruction"
                >{{ $t('Android') }}</button>
            </div>
        </div>
    </div>
</template>


<script>
import Button from "../UI/Button";
import store from "../../config/store";

export default {
    name: "MobileType",

    components: {
        Button,
        store
    },

    mounted() {

    },

    methods: {
        redirectToAndInstruction: function() {
            this.$setState("devicetype", 'android-instruction');
            console.log(123);
        },
        redirectToIphInstruction: function() {
            this.$setState("devicetype", 'iphone-instruction');
            console.log(321);
        }
    }
};
</script>
